














































import { CartItem, CartItemList as CartItemListModel } from '@/models/cart/cart-item'
import { PurchaseCountLimitRange } from '@/models/cart/purchase-count/limit/purchase-count-limit-specification'
import {
  PurchaseCountLimitSpecificationPolicy
} from '@/models/cart/purchase-count/limit/purchase-count-limit-specification-policy'
import { BundleDiscount, findBundleDiscountByFkuId } from '@/services/api/bundle-discount'
import { UsualPower } from '@/services/api/usual-power/usual-power'
import { DateFormat, formatPrice } from '@/util/format'
import Item from '@spa/components/organisms/cart/Item.vue'
import RemovedItem from '@spa/components/organisms/cart/RemovedItem.vue'
import CartItemGroupList from '@spa/components/pages/cart/components/cart/group/CartItemGroupList.vue'
import { filterValidItem, filterValidItemAsAggregate } from '@spa/store/modules/cart/function'
import { Option } from 'fp-ts/lib/Option'
import _ from 'lodash'
import Vue from 'vue'
import { Component, Prop } from 'vue-property-decorator'

/**
 * ノベルティ対応と併せてリリース想定
 * @see https://github.com/my-color/front/pull/4651#discussion_r513816879
 */
const noLayout = Vue.extend({
  name: 'NoLayout',
  template: '<div><slot></slot></div>',
})

@Component({
  components: {
    CartItemGroupList,
    RemovedItem,
    Item,
  },
})
export default class CartItemList extends Vue {
  readonly layout = noLayout

  @Prop({ required: true })
  items: CartItem[]

  @Prop({ required: true })
  removedItems: CartItem[]

  @Prop({ required: true })
  bundleDiscounts: BundleDiscount[]

  @Prop({ required: true })
  usualPowerInfo: UsualPower | null

  readonly formatPrice = formatPrice

  @Prop({ required: false })
  update: (item: CartItem, newCount: number) => ($event) => any

  @Prop({ required: false })
  remove: (item: CartItem) => () => Promise<void>

  @Prop({ required: false })
  restore: (item: CartItem) => () => Promise<void>

  /**
   * clientが状態として保持するカートリソース一覧は、親子商品のような集約を考慮したものになってない。
   * そのためclient側で疑似集約的な制約を表現するフィルタを用いる必要がある。
   */
  filterValidItemAsAggregate(item: CartItem): boolean {
    // バリデーションにあたり、表示しない商品（子商品等）も参照する必要があるため
    return filterValidItemAsAggregate(item, this.items)
  }
  /**
   * 削除のように、server側でのカート整合性・集約的な制約に依拠する処理に渡されるフィルタとしては、client側で疑似集約的な制約を表現するフィルタを用いる必要がない。
   */
  filterValidItem(item: CartItem): boolean {
    return filterValidItem(item)
  }
  findBundleDiscount(item: CartItem): Option<BundleDiscount> {
    return findBundleDiscountByFkuId(this.bundleDiscounts, item.fkuId)
  }
  formatDateToPartOfMonth(date: string): string {
    return DateFormat.partOfMonth(date)
  }

  get allItems(): CartItem[] {
    return _.orderBy(
      [...this.items, ...this.removedItems],
      (item: CartItem) => item.createdAt,
      ['desc']
    )
  }

  /**
   * 購入制限数(Root/FKU/SKU)に対するポリシー制約を参照し
   * 適切な購入可能個数レンジを返す
   */
  purchaseLimitPolicy(item: CartItem): PurchaseCountLimitRange {
    const policy = new PurchaseCountLimitSpecificationPolicy(new CartItemListModel(this.items))

    return policy.default.purchaseCountRangeFor(item)
  }
}
